module.exports = __webpack_public_path__ + "img/temperature-goal-slide2.c6c9c8b0.gif";